import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))] flex items-center pt-24 pb-12">
      <div className="container-x max-w-md mx-auto">
        <div className="overline mb-4">{t.admin.title}</div>
        <h1 className="font-serif font-light text-4xl text-[hsl(var(--foreground))]">{t.admin.login}</h1>

        <form onSubmit={submit} className="mt-10 space-y-7">
          <label className="block">
            <span className="overline">{t.admin.email}</span>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-luxe mt-2" />
          </label>
          <label className="block">
            <span className="overline">{t.admin.password}</span>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-luxe mt-2" />
          </label>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "..." : t.admin.login}
          </button>
        </form>
      </div>
    </main>
  );
}
